import { CaretDownFilled } from "@ant-design/icons"
import { ComponentPropsWithRef, ReactNode } from "react"
import { cn } from "styles/cn"

interface DisclosureProps extends ComponentPropsWithRef<"details"> {
	summary: ReactNode
	responsive?: boolean
}

export const Disclosure = ({
	summary,
	children,
	className,
	responsive = true,
	...props
}: DisclosureProps) => {
	return (
		<details
			{...props}
			className={cn(
				"group/details @container/disclosure rounded-xl border border-mint-20 open:border-green-60",
				className,
			)}
		>
			<summary
				className={cn(
					"focus-outline pointer-events-auto relative flex items-center justify-between gap-1 rounded-xl p-4 marker:hidden hover:cursor-pointer",
					responsive && "@3xl/disclosure:flex-row",
				)}
			>
				{summary}

				<CaretDownFilled
					className={cn(
						"relative text-navy-60 group-open/details:-rotate-180",
						responsive && "self-start @3xl/disclosure:self-center",
					)}
				/>
			</summary>
			<div className="p-4 group-open/details:pt-0">{children}</div>
		</details>
	)
}
